module.exports = __webpack_public_path__ + "b88adcec57fb47c66d858d887d140641.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/vr-museum.jpg
 ** module id = 395
 ** module chunks = 0
 **/